import { Injectable, inject as inject_1 } from '@angular/core';

import * as jsts from 'jsts';
import {
  LineString,
  LinearRing,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
  Geometry,
} from 'ol/geom';

import { JstsHelperService } from './jsts-helper.service';

@Injectable({
  providedIn: 'root',
})
export class IntersectGeometryService {
  private readonly jstsHelper = inject_1(JstsHelperService);

  private parser = new jsts.io.OL3Parser();

  constructor() {
    // @ts-ignore: ts doesn't have an up-to-date type for parser instance
    this.parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon,
    );
  }

  getIntersectPercentage(geometry1: Geometry, geometry2: Geometry): number {
    const geom1 = this.parser.read(geometry1);
    const geom2 = this.parser.read(geometry2).buffer(0, 4, 0);

    if (!geom1.isValid() || !geom2.isValid() || !this.jstsHelper.safeIntersects(geom1, geom2)) {
      return 0;
    }

    try {
      if (geom1.within(geom2)) {
        return 100;
      }
      const intersection = geom1.intersection(geom2);
      const percentage = (intersection.getArea() * 100) / geom1.getArea();

      return percentage;
    } catch (_error) {
      console.error('Error calculating intersection percentage:', _error);
      return 0;
    }
  }
}
